import {setTimeout} from "timers";
<template>
  <v-flex class="pl-2 pr-2 pb-2">
    <Generic_Translations
      v-if='openPartnerGroupTranslations'
      :columns="partnerGroupColumns"
      :translations="partnerGroupTranslations"
      @closeTranslations="closeAccountTranslations"
      @saveTranslations="saveTranslations"
    ></Generic_Translations>
    <v-layout
      align-start
      justify-start
      row
      class="mb-4"
    >
      <v-icon
        color="primary"
        class="ml-2"
        style="font-size: 50px;"
      >
        groups
      </v-icon>
      <h2
        :style="`color: ${$vuetify.theme.primary}`"
        class="mt-2"
      >
        {{$translate('PARTNER_GROUPS')}}
      </h2>
      <v-spacer/>
      <v-btn fab right color="secondary" @click="newItem">
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>

    <v-spacer></v-spacer>
    <v-data-table
      :headers="headers"
      :items="partnerGroups"
      class="elevation-1"
      :rows-per-page-items="[10]"
    >
      <template v-slot:items="props">
        <td>{{ props.item.PartnerGroupName }}</td>
        <td>{{ showPartnerNamesOnly(props.item.Partners)}}</td>
        <td class="justify-center">
          <v-btn
            small
            class="v-btn-tiny mr-2"
            color="primary"
            @click="getPartnerGroupDetails(props.item)"
          >
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn
            small
            class="v-btn-tiny mr-2"
            color="primary"
            @click="deleteItem(props.item)"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$translate('DELETE_PARTNER_GROUP')}}</span>
        </v-card-title>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                disabled
                v-model="partnerGroup.PartnerGroupName"
                :label="$translate('PARTNER_GROUP_NAME')"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary darken-1"
            round
            @click="dialogDelete = false"
          >{{$translate('CANCEL')}}</v-btn>
          <v-btn
            color="primary darken-1"
            :disabled="deleteDisable"
            :loading="deleteDisable"
            round
            @click="deletePartnerGroup"
          >{{$translate('DELETE')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="partnerGroupDetailsDialog"
      persistent
      no-click-animation
      max-width="1000px"
    >
      <v-container class="grey lighten-5 mt-4" grid-list-xs>
        <v-layout class="ml-4 mt-2 mb-2" justify-start align-start row>
          <v-icon color="primary" style="font-size: 50px;">border_color</v-icon>
          <h2 :style="`color: ${$vuetify.theme.primary}`" class="mt-2">{{formTitle}}</h2>
          <v-layout row justify-end>
            <v-btn
              :disabled="!partnerGroup.hasOwnProperty('PartnerGroupId')"
              fab
              small
              color="primary"
            >
              <v-icon medium @click="getTranslations">language</v-icon>
            </v-btn>
          </v-layout>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-form v-model="partnerGroupFormValid" lazy-validation ref="partnerGroupForm">
              <v-layout>
                <v-flex xs12>
                  <v-card class="blockForInputfields">
                    <v-layout class="mb-4" row wrap justify-space-around>
                      <v-flex xs5>
                        <h4>{{$translate('PARTNER_GROUP_NAME')}}</h4>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                        <v-text-field
                          v-model="partnerGroup.PartnerGroupName"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('PARTNER_GROUP_NAME')"
                          outline
                          required
                          :rules="partnerGroupNameRule"
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>Partner group logo</h4>
                        <image-loader
                          class="mt-4"
                          :properties="imageProperties"
                          v-on:load_logo="setImageElement"
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>Partner group primary color</h4>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                        <v-menu
                          ref="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                        >
                          <v-btn
                            slot="activator"
                            :color="partnerGroup.PrimaryColor"
                          >
                            Primary color
                          </v-btn>
                          <sketch-picker
                            :value="partnerGroup.PrimaryColor"
                            @input="e => partnerGroup.PrimaryColor = e.hex"
                          />
                        </v-menu>
                      </v-flex>
                      <v-flex xs5>
                        <h4>Partner group secondary color</h4>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                        <v-menu
                          ref="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                        >
                          <v-btn
                            slot="activator"
                            :color="partnerGroup.SecondaryColor"
                          >
                            Secondary color
                          </v-btn>
                          <sketch-picker
                            :value="partnerGroup.SecondaryColor"
                            @input="e => partnerGroup.SecondaryColor = e.hex"
                          />
                        </v-menu>
                      </v-flex>
                      <v-flex xs5>
                        <h4>Partner group primary font color</h4>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                        <v-menu
                          ref="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                        >
                          <v-btn
                            slot="activator"
                            :color="partnerGroup.PrimaryFontColor"
                          >
                            Primary font color
                          </v-btn>
                          <sketch-picker
                            :value="partnerGroup.PrimaryFontColor"
                            @input="e => partnerGroup.PrimaryFontColor = e.hex"
                          />
                        </v-menu>
                      </v-flex>
                      <v-flex xs5>
                        <h4>Partner group secondary font color</h4>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                        <v-menu
                          ref="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                        >
                          <v-btn
                            slot="activator"
                            :color="partnerGroup.SecondaryFontColor"
                          >
                            Secondary font color
                          </v-btn>
                          <sketch-picker
                            :value="partnerGroup.SecondaryFontColor"
                            @input="e => partnerGroup.SecondaryFontColor = e.hex"
                          />
                        </v-menu>
                      </v-flex>
                      <v-flex xs5>
                        <h4>Ios App Certificate path</h4>
                        <v-text-field
                          v-model="partnerGroup.IosAppCertificatePath"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          label="IOS App certificate path"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>Ios App Bundle ID</h4>
                        <v-text-field
                          v-model="partnerGroup.IosAppBundleId"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          label="IOS App bundle id"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>Ios App Sandbox certificate path</h4>
                        <v-text-field
                          v-model="partnerGroup.IosAppSandboxCertificatePath"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          label="IOS App sandbox certificate path"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>Ios App PK pass path</h4>
                        <v-text-field
                          v-model="partnerGroup.IosAppPKPassPath"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          label="IOS App PK Pass path"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{$translate('ANDROID_STORE_URL')}}</h4>
                        <v-text-field
                          v-model="partnerGroup.GoogleStoreListingUrl"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('ANDROID_STORE_URL')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{$translate('APPLE_STORE_URL')}}</h4>
                        <v-text-field
                          v-model="partnerGroup.AppleStoreListingUrl"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('APPLE_STORE_URL')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>Url</h4>
                        <v-text-field
                          v-model="partnerGroup.Url"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          label="Url"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>Domain</h4>
                        <v-text-field
                          v-model="partnerGroup.Domain"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          label="Domain"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>Environment</h4>
                        <v-text-field
                          v-model="partnerGroup.Environment"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          label="Environment"
                          outline
                          disabled
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                        <h4>Sign-up credits</h4>
                        <v-text-field
                          v-model="partnerGroup.SignUpCredit"
                          rows="1"
                          type="number"
                          auto-grow
                          min="0"
                          :rules="creditRule"
                          required
                          class="mb-2"
                          label="Sign-up credits"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                        <h4>App sign-up credits</h4>
                        <v-text-field
                          v-model="partnerGroup.AppSignUpCredit"
                          rows="1"
                          type="number"
                          min="0"
                          :rules="creditRule"
                          required
                          auto-grow
                          class="mb-2"
                          label="Sign-up credits"
                          outline
                        />
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout class="mt-4" row wrap justify-space-around>
                      <v-flex xs5>
                        <h4>{{$translate('PARTNER_GROUP_PARTNERS')}}</h4>
                        <v-select
                          chips
                          :label="$translate('PARTNER_GROUP_PARTNERS')"
                          v-model="selectedPartners"
                          :items="partners"
                          item-text="Name"
                          item-value="PartnerId"
                          class="mr-2 ml-2"
                          persistent-hint
                          return-object
                          deleteable-chips
                          clearable
                          multiple
                        />
                      </v-flex>
<!--                      <v-flex xs5>-->
<!--                        <h4>{{$translate('ADJUST_PARTNERS_FROM_PARTNERGROUP')}}</h4>-->
<!--                       <v-card-->
<!--                         class="mt-2 pa-2 elevation-0"-->
<!--                         style="border: 1px solid black;"-->
<!--                         v-for="(partner, index) in selectedPartners"-->
<!--                         :key="index"-->
<!--                       >-->
<!--                         <v-layout column>-->
<!--                         <h4 class="mb-1">{{partner.Name}}</h4>-->
<!--                         <v-checkbox-->
<!--                           v-model="partner.UsingCommonApp"-->
<!--                           :label="$translate('USING_COMMON_APP')"-->
<!--                           hide-details-->
<!--                         />-->
<!--                           <v-checkbox-->
<!--                             v-model="partner.MainPartner"-->
<!--                             label="Main partner"-->
<!--                             hide-details-->
<!--                             :disabled="!partner.MainPartner && mainPartnerSelected"-->
<!--                           />-->
<!--                         </v-layout>-->
<!--                       </v-card>-->
<!--                      </v-flex>-->
                      <v-flex xs5 v-for="item in selectedPartners" :key="item">
                        <h4>{{$translate('PARTNER_LEVEL')}} {{item.Name}}</h4>
                        <v-select
                          v-model="item.PartnerLevel"
                          :items="partnerLevels"
                          :label="$translate('PARTNER_LEVEL')"
                          item-text="Name"
                          item-value="Name"
                          outline
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout class="mt-4 pb-4" row wrap justify-space-between>
          <v-spacer></v-spacer>
          <v-flex class="pl-4 pr-4" xs2>
            <v-btn
              color="secondary"
              round
              block
              @click="close"
            >
              {{ $translate('CANCEL') }}
            </v-btn>
          </v-flex>
          <v-flex class="pl-4 pr-4" xs2>
            <v-btn
              color="primary"
              round
              block
              @click="saveNewPartnerGroup"
            >
              {{ $translate('SAVE') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-dialog v-model="doublePartnerGroupDialog" persistent max-width="390">
      <v-card class="confirmLoadingDialog">
        <v-layout column justify-center align-start>
          <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
          <v-card-text>
            <p>{{ $translate('DUPLICATED_PARTNER_GROUP_NAME_ERROR') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-flex>
              <v-btn
                round
                color="primary"
                @click="doublePartnerGroupDialog = false"
              >
                {{ $translate('CANCEL') }}
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
  import * as dssRequest from '@/api/dssRequest';
  import BaseComponent from '../base/BaseComponent.vue';
  import { Sketch } from "vue-color";
  import ImageLoader from '../media/ImageLoader';
  import Generic_Translations from '../Generic_Translations';
  import appConfig from '../../../config/app_config';
  import _ from 'lodash';


  export default
{
  extends: BaseComponent,
  name: 'AccountPartnerGroups',
  components: {
    Generic_Translations,
    ImageLoader,
    "sketch-picker": Sketch,
  },
  computed: {
    formTitle() {
      return this.editMode ? `Details of ${this.partnerGroup.PartnerGroupName}` : 'New PartnerGroup';
    },
    mainPartnerSelected() {
      let mainPartnerAlreadySelected = false;
      this.selectedPartners.forEach((partner) => {
        if (partner.MainPartner) mainPartnerAlreadySelected = true;
      });
      return mainPartnerAlreadySelected;
    },
  },
  data() {
    return {
      // Translations
      openPartnerGroupTranslations: false,
      partnerGroupColumns: [],
      partnerGroupTranslations: {},

      //Logo props
      imageProperties: {
        title: "Logo",
        signalName: "load_logo",
        deletable: false,
        pictureUrl: "",
        maxWidth: appConfig.maxSize.logo.w,
        maxHeight: appConfig.maxSize.logo.h,
        scale: "h",
      },
      // Partner groups
      partnerGroups: [],
      partnerGroup: {},
      partnerGroupTemplate: {
        PartnerGroupName: '',
        Logo: '',
        PrimaryColor: '',
        SecondaryColor: '',
        PrimaryFontColor: '',
        SecondaryFontColor: '',
        Partners: [],
        AppSignUpCredit: 0,
        SignUpCredit: 0,
      },
      partnerGroupDetailsDialog: false,
      editMode: false,
      partners: [],
      selectedPartners: [],
      creditRule: [(v) => (v => 0) || 'A credit for the partner group is required'],
      partnerGroupNameRule: [(v) => !!v || 'A name for the partner group is required'],
      doublePartnerGroupDialog: false,
      // partnerGroups Table
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'PartnerGroupName',
        },
        {
          text: 'Partners',
          align: 'left',
          sortable: true,
          value: 'Partners',
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: '',
        },
      ],
      partnerGroupFormValid: false,
      deleteDisable: false,
      dialogDelete: false,
      partnerLevels: [
        {
          Name: 'MainPartner',
          Value: 40,
        },
        {
          Name: 'FullPartner',
          Value: 30,
        },
        {
          Name: 'DeliveryPartner',
          Value: 20,
        },
        {
          Name: 'ProductSupplier',
          Value: 10,
        },
      ],
    };
  },
  mounted() {
    this.getPartnerGroups();
  },
  methods: {
    closeAccountTranslations() {
      this.openPartnerGroupTranslations = false;
    },
    getTranslations() {
      console.log("Lorenzo this.partnerGroup", this.partnerGroup);
      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call getTranslations on - Account_PartnerGroups.vue - was successful', response);
          this.partnerGroupTranslations = {};
          this.partnerGroupColumns = [];
          this.partnerGroupTranslations = response.data.Translations;
          this.partnerGroupColumns = response.data.ColumnNames;
          this.openPartnerGroupTranslations = true;
        },
        (error) => {
          console.log('The generic call getTranslations on - Account_PartnerGroups.vue - was not successful', error);
        },
        'getTranslations',
        this.partnerGroup.PartnerGroupId,
        payload,
      );
    },
    saveTranslations(translationData) {
      let payload = {};
      payload.Translations = translationData;
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for saveTranslations on - Account_PartnerGroups.vue - was successful",
            response
          );
          this.openPartnerGroupTranslations = false;
        },
        (error) => {
          console.log(
            "The call for saveTranslations on - Account_PartnerGroups.vue - was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'saveTranslations',
        this.partnerGroup.PartnerGroupId,
        payload,
      );
    },
    setImageElement(e) {
      console.log("Brian e, this.imageProperties", e, this.imageProperties);

      if (e.signalName === this.imageProperties.signalName) {
        this.partnerGroup.Logo = e.url;
      }
    },
    showPartnerNamesOnly(partners) {
      return partners.map((i) => {
        return i.Name;
      }).toString();
    },
    getPartners() {
      // Action for loading all the Partners in the current account
      const payload = {
        FunctionId: 'AccountFunctionLibrary::getPartners',
      };
      dssRequest.doRequest(
        (response) => {
          console.log('the call for getPartners was successful', response);
          // Clear the current partners array
          this.partners.length = 0;
          for (const [k, v] of Object.entries(response.data.Partners)) {
            this.partners.push({ PartnerId: k, UsingCommonApp: true, Name: v.Name });
          }
        },
        (error) => {
          console.log('the call for getPartners was not successful', error);
        },
        'communicateWithDBLibrary',
        this.currentAccountId,
        payload,
      );
    },
    getPartnerGroups() {
      // Action for loading all the partnerGroups in the current account
      const payload = {
      };
      dssRequest.doRequest(
        (response) => {
          console.log('the call for getPartnerGroups was successful', response);
          // Clear the current partnerGroups array
          this.partnerGroups.length = 0;
          this.partnerGroups = response.data.PartnerGroups;
        },
        (error) => {
          console.log('the call for getPartnerGroups was not successful', error);
        },
        'getPartnerGroups',
        `${this.currentAccountId}_PGM`,
        payload,
      );
    },
    getPartnerGroupDetails(partnerGroup) {
      // Action for loading all the partnerGroups in the current account
      const payload = {
        PartnerGroupId: partnerGroup.PartnerGroupId,
        FullPicture: true,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('the call for getPartnerGroupDetails was successful', response);
          // Action for clicking on the edit button in the PartnerGroup screen
          this.selectedPartners = response.data.Partners;
          this.imageProperties.pictureUrl = response.data.Logo;
          this.partnerGroup = { ...response.data};
          this.editMode = true;
          this.partnerGroupDetailsDialog = true;
          this.getPartners();
        },
        (error) => {
          console.log('the call for getPartnerGroupDetails was not successful', error);
        },
        'getPartnerGroupDetails',
        partnerGroup.PartnerGroupId,
        payload,
      );
    },
    close() {
      console.log("Brian are we getting here? ", this.partnerGroup);

      this.partnerGroup = {};
      this.$refs.partnerGroupForm.resetValidation();
      this.partnerGroupDetailsDialog = false;
      console.log("Brian are we getting here? ", this.partnerGroup);
    },
    newItem() {
      // Action for clicking on the plus button in the partnerGroup screen
      console.log("Brian this.partnerGroupTemplate", this.partnerGroupTemplate);
      this.getPartners();
      this.partnerGroup = _.cloneDeep(this.partnerGroupTemplate);
      this.selectedPartners = [];
      this.imageProperties = {
        title: "Logo",
        signalName: "load_logo",
        deletable: false,
        pictureUrl: "",
        maxWidth: appConfig.maxSize.logo.w,
        maxHeight: appConfig.maxSize.logo.h,
        scale: "h",
      };
      this.$refs.partnerGroupForm.resetValidation();
      this.editMode = false;
      this.partnerGroupDetailsDialog = true;
    },
    deleteItem(item) {
      // Action for clicking on the delete button in the PartnerGroup screen
      this.partnerGroup = { ...item };
      this.dialogDelete = true;
    },
    saveNewPartnerGroup() {
      // Action for clicking on the SAVE button in the partnerGroup details dialog
      // check if the primary color & secondary color are both filled in or not
      if (
        this.partnerGroup.PrimaryColor === ''
        || this.partnerGroup.SecondaryColor === ''
      ) {
        window.EventBus.fire(
          "activateSnackBar",
          this.$translate('SELECT_PRIMARY_AND_SECONDARY_COLOR'),
        );
        return;
      }
      this.selectedPartners.forEach((partner) => {
        if (!partner.hasOwnProperty('MainPartner')) {
          partner.MainPartner = false;
        }
      })
      if (this.$refs.partnerGroupForm.validate()) {
        this.partnerGroup.Partners = this.selectedPartners;
        const payload = { ...this.partnerGroup };
        if (this.editMode) payload.PartnerGroupId = this.partnerGroup.PartnerGroupId;
        dssRequest.doRequest(
          (response) => {
            console.log(
              'the call for savePartnerGroup was successful',
              response,
            );
            this.close();
            this.getPartnerGroups();
          },
          (error) => {
            console.log(
              'the call for savePartnerGroup was not successful',
              error,
            );
            if (error.data.hasOwnProperty('ErrorCode') && error.data.ErrorCode.includes('E_DA_001')) {
              this.doublePartnerGroupDialog = true;
            }
          },
          'savePartnerGroup',
          `${this.currentAccountId}_PGM`,
          payload,
          600000,
          false,
        );
      }
    },
    deletePartnerGroup() {
      // Action for clicking on the DELETE button in the delete dialog
      const payload = {
        PartnerGroupId: this.partnerGroup.PartnerGroupId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('the call for deletePartnerGroup was successful', response);
          this.dialogDelete = false;
          this.getPartnerGroups();
        },
        (error) => {
          console.log('the call for deletePartnerGroup was not successful', error);
        },
        'deletePartnerGroup',
        `${this.currentAccountId}_PGM`,
        payload,
      );
    },
  },
};
</script>

<style>
  .blockForInputfields {
    padding: 1em;
  }
</style>
